"use client";

import { createSVGIcon } from "@faire/slate/lib/iconUtils";
import React from "react";

/**
 * @figma designed by Gabe Kelley (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=8944%3A1587))
 * @trackcomponent
 * @lastsynced 2025-07-07T16:19:10.646Z
 * @optimized using svgo:^3.0.2
 */
export const Malta = createSVGIcon(
  <>
    <path fillRule="evenodd" clipRule="evenodd" d="M1 2h8v12H1z" fill="#fff" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 4H4v1.496A.5.5 0 0 0 3.616 6H2v2h1.665A.5.5 0 0 0 4 8.27V10h2V8.275A.5.5 0 0 0 6.367 8H8V6H6.415v-.017A.5.5 0 0 0 6 5.49z"
      fill="#A0A0A0"
    />
    <mask
      id="mask0_8944_1587"
      style={{ maskType: "luminance" }}
      maskUnits="userSpaceOnUse"
      x="2"
      y="4"
      width="6"
      height="6"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 4H4v1.496A.5.5 0 0 0 3.616 6H2v2h1.665A.5.5 0 0 0 4 8.27V10h2V8.275A.5.5 0 0 0 6.367 8H8V6H6.415v-.017A.5.5 0 0 0 6 5.49z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#mask0_8944_1587)">
      <path
        d="M4 4v-.5h-.5V4zm2 0h.5v-.5H6zM4 5.496l.115.486.385-.09v-.396zM3.616 6v.5h.517l-.017-.517zM2 6v-.5h-.5V6zm0 2h-.5v.5H2zm1.665 0 .45-.218L3.98 7.5h-.313zM4 8.27h.5v-.396l-.385-.091zM4 10h-.5v.5H4zm2 0v.5h.5V10zm0-1.725-.083-.492-.417.07v.422zM6.367 8v-.5h-.314l-.137.282zM8 8v.5h.5V8zm0-2h.5v-.5H8zM6.415 6l-.5-.017L5.9 6.5h.517zM6 5.49h-.5v.422l.417.071zM4 4.5h2v-1H4zm.5.996V4h-1v1.496zm-.384.487zl-.231-.973a1 1 0 0 0-.768.973zm0 0h-1v.034zM2 6.5h1.616v-1H2zM2.5 8V6h-1v2zm1.166-.5H2v1h1.665zm.449.283-.9.434a1 1 0 0 0 .67.539zM4.5 10V8.27h-1V10zM6 9.5H4v1h2zm-.5-1.225V10h1V8.275zm.583.493a1 1 0 0 0 .733-.55l-.9-.436zM8 7.5H6.367v1H8zM7.5 6v2h1V6zm-1.084.5H8v-1H6.415zm-.5-.517 1 .034v-.034zm0 0q-.002 0 0 0 0-.002 0 0h1a1 1 0 0 0-.833-.986zM5.5 4v1.49h1V4z"
        fill="#FECA00"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 2h8v12H9z"
      fill="#E31D1C"
    />
    <path stroke="#757575" d="M1 2H17V14H1z" />
  </>,
  "Malta",
  { fill: "none", viewBox: "0 0 18 16" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
